import {FormFieldProps, SelectOption} from '..'

const name: FormFieldProps = {
  name: 'name',
  type: 'text',
  label: 'Name',
  required: true,
  help: 'Short name or summary for this rule',
}

const trips: FormFieldProps = {
  name: 'tripIds',
  type: 'select',
  label: 'Trip',
  options: [] as SelectOption[],
  searchable: true,
  multi: true,
  placeholder: 'Select one or more Trips...',
  help: 'Applies to all if no Trips specified.',
}

const team: FormFieldProps = {
  name: 'team',
  type: 'switch',
  label: 'Team Access',
  required: true,
  help: 'Viewable by all team members?',
}

const token: FormFieldProps = {
  name: 'token',
  type: 'text',
  label: 'Token',
  help: 'Password to view without an account.',
}

export const AddAclForm = {name, trips, team, token}
export const UpdateAclForm = {name, trips, team, token}
